export const testIds = {
    closeButton: 'ModalCloseButton'
} as const;
